import { BlogSection } from '@/types/blog';

export const fuerWen: BlogSection = {
  id: 'fuer-wen',
  title: 'Für wen ist dieser Weg?',
  content: `
<p>Dieser Weg ist für Führungskräfte bis hin zum C-Level, die spüren, dass klassisches „Durchpeitschen" an seine Grenzen stößt. Er ist für Menschen, die ihre differenzierte Wahrnehmung nicht als Bremse, sondern als unternehmerische Ressource begreifen wollen.</p>

<p>Ob im <a href="/executive-coaching" rel="noopener">Executive Coaching</a> oder in der Begleitung ganzer Führungsteams: Wir suchen nicht nach der lautesten Lösung, sondern nach der klarsten.</p>
  `
};
